import type { TechnicalInfoCategory, TechnicalInfoData } from "~/features/search/models/SearchResultsDTO";
import { Grid, Stack } from "~/common/mui";
import { LinkList, LinkListItem } from "~/common/components/LinkList/LinkList"; // Grid version 2
import { useTranslation } from "react-i18next";
import RenderServerSideContent from "~/common/components/RenderServerSideContent";

interface Props {
  data: TechnicalInfoData | null | undefined;
  cmsContent?: Element;
}

export const MoreInformationTab = (props: Props) => {
  const { t } = useTranslation();

  if (!props.data?.columns && !props.cmsContent) {
    return null;
  }

  const getLinkType = (openInNewTab: boolean, column: TechnicalInfoCategory) => {
    if (openInNewTab) {
      return "NEWTAB";
    }

    const isPublications = column?.title === t("more.info.column.PUBLICATIONS");
    return isPublications ? "DOWNLOAD" : "SAMETAB";
  };

  return (
    <Stack
      sx={{
        gap: 8,
      }}
    >
      <Grid container rowSpacing={3}>
        {props.cmsContent && (
          <Grid size={12}>
            <RenderServerSideContent content={props.cmsContent} />
          </Grid>
        )}
        {props.data?.columns?.map((column) => (
          <Grid
            size={{
              phone: 12,
              "desktop-s": 4,
            }}
          >
            <LinkList key={column.title} title={column.title} seeMoreUrl={column.viewMoreURL}>
              {column.items &&
                column.items.map((item) => (
                  <LinkListItem
                    key={item.name}
                    href={item.url}
                    headline={t(item.name)}
                    subheadline={item.assetTypeLabel ? t(item.assetTypeLabel) : undefined}
                    overline={item.overline ? t(item.overline) : undefined}
                    linkType={getLinkType(item.openInNewTab, column)}
                  />
                ))}
            </LinkList>
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
};
